import PeriprocedureelBeleidApixaban from "../../../../src/client/lta-antistolling/periprocedureel-beleid-apixaban.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  PeriprocedureelBeleidApixaban,
  ChartCollapse,
  React
};